import { forwardRef } from "react";
import { cn } from "@/lib/cn";
import { Skeleton } from "@/components/ui/feedback/Skeleton";
import { Spinner } from "@/components/ui/feedback/Spinner";
import type { LoadingStateProps } from "./LoadingState.types";

export const LoadingState = forwardRef<HTMLDivElement, LoadingStateProps>(
  ({ className, label = "Loading", description, variant = "spinner", rows = 4, ...props }, ref) => (
    <div ref={ref} className={cn("bfrs-flex bfrs-min-h-44 bfrs-flex-col bfrs-items-center bfrs-justify-center bfrs-gap-3 bfrs-rounded-lg bfrs-bg-surface-card bfrs-px-6 bfrs-py-8 bfrs-text-center", className)} role="status" aria-live="polite" {...props}>
      {variant === "spinner" ? (
        <>
          <Spinner size="lg" label={typeof label === "string" ? label : "Loading"} className="bfrs-text-primary" />
          <div>
            <div className="bfrs-text-sm bfrs-font-semibold bfrs-text-text-secondary">{label}</div>
            {description && <div className="bfrs-mt-1 bfrs-text-xs bfrs-leading-5 bfrs-text-text-muted">{description}</div>}
          </div>
        </>
      ) : (
        <div className="bfrs-w-full bfrs-max-w-md bfrs-space-y-3">
          {Array.from({ length: rows }).map((_, index) => (
            <Skeleton key={index} variant="text" className={cn(index % 3 === 0 ? "bfrs-w-5/6" : index % 3 === 1 ? "bfrs-w-full" : "bfrs-w-3/4")} />
          ))}
        </div>
      )}
    </div>
  )
);

LoadingState.displayName = "LoadingState";
